import { useLocation } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { useTour } from './TourProvider.tsx';

/**
 * First-visit offer of the general tour, inside the page flow on the home screen only: it never covers the screen
 * and disappears for good once answered (per user, progress.ts).
 */
export function TourOffer() {
  const { progress, running, start, dismissOffer } = useTour();
  const { pathname } = useLocation();
  if (pathname !== '/' || running || progress.offerDismissed) return null;
  return (
    <section className="card tour-offer" aria-label="Tour guiado" data-testid="tour-offer">
      <p style={{ marginTop: 0 }}>
        <Compass size={18} aria-hidden="true" style={{ verticalAlign: 'text-bottom' }} />{' '}
        <strong>Primeiro acesso?</strong> Um tour curto mostra o menu, a trilha de navegação, o estado da
        conexão e onde encontrar ajuda. Ele pode ser interrompido e retomado depois em Ajuda.
      </p>
      <div className="actions">
        {/* Plain .btn (styles.css), not the Button component: keeps components/actions out of the first bundle. */}
        <button type="button" className="btn primary" onClick={() => start('geral')}>
          Iniciar tour
        </button>
        <button type="button" className="btn ghost" onClick={dismissOffer}>
          Agora não
        </button>
      </div>
    </section>
  );
}
